const DEBOUNCE_DELAY_500 = 500;

export { DEBOUNCE_DELAY_500 };
